import { Button, Grid, Input, Typography } from "@mui/material";
import { vec3 } from "gl-matrix";
import { useEffect, useState } from "react";
import Common from "../Refinery/CommonRender";
import Light from "../Refinery/Lights/Light";
import { LabeledInput } from "./ObjectControls";

export type LightControlsData = {
  colour: vec3;
  position: vec3;
  strength: number;
};

export type LightControlsProps = {
  selectedObject?: Light;
  onClone: () => void;
  onDelete: () => void;
  onSelectedChange: (value: LightControlsData) => void;
};

export const LightControls = (props: LightControlsProps) => {
  const [positionX, setPositionX] = useState<string | undefined>(undefined);
  const [positionY, setPositionY] = useState<string | undefined>(undefined);
  const [positionZ, setPositionZ] = useState<string | undefined>(undefined);


  useEffect(() => {
    if (props.selectedObject) {
      setPositionX(props.selectedObject.position[0].toFixed(2).toString());
      setPositionY(props.selectedObject.position[1].toFixed(2).toString());
      setPositionZ(props.selectedObject.position[2].toFixed(2).toString());
    }
  }, [props.selectedObject]);


  const handlePositionChange = (value: string, index: number, setter: (v: string) => void) => {
    if (!props.selectedObject) return;

    let newValue = 0;
    setter(value)

    if (value !== '') {
      newValue = parseFloat(value);
    }

    const newPosition = vec3.fromValues(
      props.selectedObject.position[0],
      props.selectedObject.position[1],
      props.selectedObject.position[2]);

    newPosition[index] = newValue;
    const data: LightControlsData = {
      ...props.selectedObject,
      position: newPosition,
    };
    props.onSelectedChange(data);
  };

  return (
    <Grid container direction='row'>
      <Grid size={12} spacing={2}>
        {/* left box */}
        <Grid size={12}>
          <Grid container direction='row' spacing={1}>
            <Grid size={12}>
              <Typography color="textSecondary">Position</Typography>
            </Grid>
            <Grid size={4}>
              <LabeledInput
                label="X"
                value={positionX}
                onBlur={() => {
                  if (positionX === "") {
                    setPositionX("0");
                  }
                }}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handlePositionChange(event.target.value, 0, setPositionX);
                }}
              />
            </Grid>
            <Grid size={4}>
              <LabeledInput
                label="Y"
                value={positionY}
                onBlur={() => {
                  if (positionY === "") {
                    setPositionY("0");
                  }
                }}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handlePositionChange(event.target.value, 1, setPositionY);
                }}
              />
            </Grid>
            <Grid size={4}>
              <LabeledInput
                label="Z"
                value={positionZ}
                onBlur={() => {
                  if (positionZ === "") {
                    setPositionZ("0");
                  }
                }}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handlePositionChange(event.target.value, 2, setPositionZ);
                }}
              />
            </Grid>
          </Grid>
          <Grid size={12}>
            <Typography color="textSecondary">Strength</Typography>
          </Grid>
          <Grid size={12}>
            <Input
              type="number"
              value={props.selectedObject?.strength}
              onChange={(e) => {
                if (!props.selectedObject) {
                  return;
                }
                let strengthValue = parseFloat(e.target.value);
                if (isNaN(strengthValue)) {
                  strengthValue = 1.0;
                }
                props.onSelectedChange({
                  ...props.selectedObject,
                  strength: strengthValue,
                });
              }}
              inputProps={{
                min: 1,
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid size={12}>
        {/* Colour */}
        <Grid container direction='column' spacing={2}>
          <Grid size={12}>
            <Typography color="textSecondary">Colour</Typography>
          </Grid>
          <Grid size={12}>
            <Input
              type='color'
              sx={{ width: '40px' }}
              value={Common.rgbToHex(props.selectedObject?.colour ?? vec3.create())}
              onChange={(e) => {
                if (!props.selectedObject) {
                  return;
                }
                const hexVal = e.target.value;
                props.onSelectedChange({
                  ...props.selectedObject,
                  colour: Common.hexToRGB(hexVal),
                })
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid size={12} container spacing={2}>
        <Grid size={12}>
          <Typography color="textSecondary">Options</Typography>
        </Grid>
        <Grid container spacing={2} size={12}>
          <Button
            onClick={async () => {
              props.onClone();
            }}
            variant='outlined'
          >Clone</Button>
          <Button
            color="error"
            onClick={async () => {
              props.onDelete();
            }}
            variant='outlined'
          >Delete</Button>
        </Grid>
      </Grid>
    </Grid>
  )
};
